import cn from 'classnames';
import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';
import Layout from '@/features/page/processors/components/layout';
import IntrinsicElements = React.JSX.IntrinsicElements;

interface LayoutProcessorElement extends Element {
  props: Element['props'] & {
    tagName: keyof IntrinsicElements;
    inlineStyles?: string;
    customClasses?: string;
    'data-erom-inline-styles'?: string;
    'data-erom-layout-inline-styles'?: string;
    'data-erom-styles-classes'?: string;
    'data-erom-layout-classes'?: string;
  };
}

const layout: Processor<LayoutProcessorElement> = {
  priority: 98,
  name: 'layout',
  test: ({ node }) =>
    node.props?.hasOwnProperty('data-erom-inline-styles') ||
    node.props?.hasOwnProperty('data-erom-layout-inline-styles') ||
    node.props?.hasOwnProperty('data-erom-styles-classes') ||
    node.props?.hasOwnProperty('data-erom-layout-classes'),
  processor: ({ node }) => {
    node.props.tagName = node.component as keyof IntrinsicElements;
    node.props.inlineStyles =
      [node.props['data-erom-inline-styles'], node.props['data-erom-layout-inline-styles']]
        .filter(Boolean)
        .join('\n') ?? '';
    node.props.customClasses = cn(
      node.props['data-erom-styles-classes'] ?? '',
      node.props['data-erom-layout-classes'] ?? ''
    );
    node.props['data-erom-inline-styles'] = undefined;
    node.props['data-erom-layout-inline-styles'] = undefined;
    node.props['data-erom-styles-classes'] = undefined;
    node.props['data-erom-layout-classes'] = undefined;

    node.component = Layout as ComponentType;

    return node;
  }
};

export default layout;
